export default "__VITE_ASSET__24f0a876__"